import { render } from "./DashboardListItem.vue?vue&type=template&id=4203dfa7&scoped=true"
import script from "./DashboardListItem.vue?vue&type=script&lang=js"
export * from "./DashboardListItem.vue?vue&type=script&lang=js"

import "./DashboardListItem.vue?vue&type=style&index=0&id=4203dfa7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4203dfa7"]])

export default __exports__